import * as React from 'react';
import {FormTransferContainer} from "../../form/FormTransferContainer";
import {FormGroup} from "../../form/FormGroup";
import {FormInput} from "../../form/FormInput";
import {Validators} from "../../form/Validators";
import {FormComponentProps} from "../../form/Form";

const CONFIGURATION_MODEL: string = 'configuration';

interface TimedTournamentProps extends FormComponentProps {
}

interface TimedTournamentState {
    isTimedTournament: boolean;
}

export class TimedTournamentPanel extends React.Component<TimedTournamentProps, TimedTournamentState> {
    constructor(props) {
        super(props);
        this.state = {isTimedTournament: this.isTimedTournament()}
    }

    getConfigurationModel() {
        return this.props.fieldSet.getModelValue(CONFIGURATION_MODEL);
    }

    isTimedTournament(): boolean {
        return this.getConfigurationModel().timedTournamentsDurationMinutes != null;
    }

    resetTimedTournamentSettings() {
        this.props.fieldSet.updateModel('configuration.timedTournamentsDurationMinutes', null , false, {errorName: null, pristine: false})
    }

    private handleInputChange = event => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        if(value === false) this.resetTimedTournamentSettings();

        this.setState({
            isTimedTournament: value
        });
    }

    render() {
        return (
            <FormTransferContainer {...this.props}>
                <div className='row target-tournament-panel'>
                    <div className='col-lg-12'>
                        <div className='ibox float-e-margins'>
                            <div className='ibox-title'>
                                <h5>Timed Tournaments</h5>
                            </div>
                            <div className='ibox-content'>
                                <FormGroup className='form-group'>
                                    <label className='col-sm-2 control-label'>Is Timed Tournament</label>
                                    <div className='col-sm-10'>
                                        <input type="checkbox" checked={this.state.isTimedTournament} onChange={this.handleInputChange}/>
                                    </div>
                                </FormGroup>
                                {this.state.isTimedTournament && <div>
                                    <div className='hr-line-dashed'></div>
                                    <FormGroup className='form-group'>
                                        <label className='col-sm-2 control-label'>Tournament Duration (In whole minutes) </label>
                                        <div className='col-sm-10'>
                                            <FormInput type='integer' model='configuration.timedTournamentsDurationMinutes'
                                                       className='form-control' validators={[Validators.required(), Validators.min(1)]}/>
                                            <span className='help-block m-b-none'>Must be a positive integer, no decimal places</span>
                                        </div>
                                    </FormGroup>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </FormTransferContainer>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/poker/tournament/TimedTournamentPanel.tsx